module.exports = __webpack_public_path__ + "static/media/mini.69446979.png";